var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('svg',{attrs:{"width":"6","height":"3","viewBox":"0 0 6 3","fill":"none","xmlns":"http://www.w3.org/2000/svg"}},[_c('path',{attrs:{"d":"M5.41675 -5.24521e-06L2.70841 2.70833L8.10623e-05 -5.24521e-06L5.41675 -5.24521e-06Z","fill":"black"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }